import type {TKey} from '@/translations/i18n'
import {Space} from './types'

export const LOCALSTORAGE_KEY_SHOOTLIST_CARD_PREFIX = 'shootlist-flags'

export const SPACE_KEY_TO_LABEL = {
    bathroom: {label: 'spaces:bathroom', value: null},
    bedroom_1: {label: 'spaces:bedroom_x', value: 1},
    bedroom_2: {label: 'spaces:bedroom_x', value: 2},
    bedroom_3: {label: 'spaces:bedroom_x', value: 3},
    bedroom_4: {label: 'spaces:bedroom_x', value: 4},
    bedroom_5: {label: 'spaces:bedroom_x', value: 5},
    bedroom_6: {label: 'spaces:bedroom_x', value: 6},
    bedroom_7: {label: 'spaces:bedroom_x', value: 7},
    bedroom_8: {label: 'spaces:bedroom_x', value: 8},
    bedroom_9: {label: 'spaces:bedroom_x', value: 9},
    bedroom_10: {label: 'spaces:bedroom_x', value: 10},
    common_spaces: {label: 'spaces:common_spaces', value: null},
    dining_room: {label: 'spaces:dining_room', value: null},
    exterior: {label: 'spaces:exterior', value: null},
    kitchen: {label: 'spaces:kitchen', value: null},
    living_room: {label: 'spaces:living_room', value: null},
    office_study: {label: 'spaces:office_study', value: null},
    other: {label: 'spaces:other', value: null},
    outdoor_space: {label: 'spaces:outdoor_space', value: null},
    pool_host_tub: {label: 'spaces:pool_host_tub', value: null},
    hotel_exterior_day_dusk: {label: 'spaces:hotel_exterior_day_dusk', value: null},
    hotel_parking_pathway_entrance: {label: 'spaces:hotel_parking_pathway_entrance', value: null},
    hotel_lobby_front_desk: {label: 'spaces:hotel_lobby_front_desk', value: null},
    hotel_indoor_common_space: {label: 'spaces:hotel_indoor_common_space', value: null},
    hotel_outdoor_common_space: {label: 'spaces:hotel_outdoor_common_space', value: null},
    hotel_private_room_suites: {label: 'spaces:hotel_private_room_suites', value: null},
    hotel_bathroom: {label: 'spaces:hotel_bathroom', value: null},
    hotel_wellness_space: {label: 'spaces:hotel_wellness_space', value: null},
    hotel_restaurant_bar: {label: 'spaces:hotel_restaurant_bar', value: null},
    hotel_professional_space: {label: 'spaces:hotel_professional_space', value: null},
    hotel_accessibility_features: {label: 'spaces:hotel_accessibility_features', value: null}
} as const satisfies Record<Space['space']['key_name'], {label: TKey; value: number | null}>

export const ASSIGNMENT_DESCRIPTION_WRAPPER_CLASSNAME =
    'grid grid-cols-1 grid-rows-[auto_auto] gap-8 md:grid-cols-[1fr_auto] md:grid-rows-none md:gap-20'
export const ASSIGNMENT_DESCRIPTION_TEXT_CLASSNAME = 'flex flex-col gap-2'
export const ASSIGNMENT_DESCRIPTION_TITLE_CLASSNAME = 'text-display-xs font-bold'
export const ASSIGNMENT_DESCRIPTION_PARAGRAPH_CLASSNAME =
    'text-md [&_strong]:font-medium [&_strong]:text-success-600 [&_b]:font-medium [&_a]:cursor-pointer [&_a]:underline'

export const ASSIGNMENT_CARD_WRAPPER_CLASSNAME =
    'flex flex-col gap-4 w-full rounded-none border border-neutral-300 bg-white p-6 md:max-w-none md:rounded-2xl'
export const ASSIGNMENT_CARD_TITLE_CLASSNAME = 'text-lg font-semibold'
export const ASSIGNMENT_CARD_SUBTITLE_CLASSNAME = 'text-sm font-normal'
